/**
* Na potrzeby aktualizaji jQuery do wersji 3.1.1: metoda $.load() została zastąpiona metodą $.on()
*/
app.service('dispatcher',function(front, goBack, searchBox, html, log, autocomplete, productPromotionsListModal, statusDelivery, sticky, cartBox, account, partnerSubscriptionManager,
								  availabilityNotification, energyLabel, reportBug, scrollTop, regulations, cartManager, menuBar, focusTrap, modalDictionary,
								  seeAlso, message, nodeTree, lazyLoad, selectCity, loading, console, brandView, definitionsView, productsListView, productVariants, cookie,
								  modal, callButton, filterBar, mainPageView, pageConfig, validate, captchaService, dataSeoUrl, sessionStorage, ajaxPage, footerRecentArticles,
								  emptySearchResultsView, holidayPromotion, relatedPromotionCommercial, tooltip, wcagSkipLinks, topContactInfoModal, comparisonBar, comparisonButtonManager, durabilityGuaranteeLayer, simpleModal) {
	$(document).on('pageChange',function(){
		run();
	});
	function run(){		// po wymianie strony bez przeładowania
		if(!$('#order-path, #order-path-native-app').length){				//inne widoki niż ścieżka
			sessionStorage.removeItem("sdfghytu");
		}
		goBack.setRefPage();
		var $rotator = $('.js-rotator');
		$rotator.rotator();
		$rotator.find('img').each(function() {
			var src = $(this).data('original');
			$(this).attr('src', src);
		});
		$('#category-tree').menuMultilevel();
		$('#footer-links').menuMultilevel();
		checkErrors();
		var currentPage = front.page();
		var excluded = ['search', 'leaf', 'product'];
		if( excluded.indexOf( currentPage ) === -1 ) {
			log.visit();
		}
		availabilityNotification.init();
		switch( currentPage ) {
			case 'main-page':
				mainPageView.init();
				break;
			case 'brand':
				brandView.init();
				break;
			case 'brand':
				filterBar.init();
				break;
			case 'definition':
				definitionsView.init();
				break;
				case 'leaf': case 'search':
				productsListView.init();
				break;
			case 'empty-search-results':
				emptySearchResultsView.init();
				break;
			default:
				break;
		}
		$('body').attr('wdio-random', parseInt(Math.random()*100000000));
	}
	function pageRun(){		// tylko raz na odświeżenie
		cartBox.init();
		account.init();
		scrollTop.init();
		searchBox.init();
		reportBug.init();
		energyLabel.init();
		durabilityGuaranteeLayer.init();
		simpleModal.init();
		statusDelivery.init();
		sticky.init();
		lazyLoad.init();
		ajaxPage.init();
		productVariants.init();
		callButton.init();
		modalDictionary.init();
		focusTrap.init();
		menuBar.init();
		seeAlso.init();
		nodeTree.init();
		selectCity.init();
		partnerSubscriptionManager.init();
		captchaService.init();
		dataSeoUrl.init();
		holidayPromotion.init();
		relatedPromotionCommercial.init();
		footerRecentArticles.init();
		getAdditionalPageContent();
		tooltip.init();
		wcagSkipLinks.init();
		topContactInfoModal.init();
		comparisonBar.init();
		comparisonButtonManager.init();

		$('body').on('click', '.js-terminal-enabled', function() {
			message.get('product-card-payment-on-euro-delivery-message').then(function(html){
				modal.generate({
					id:'terminal-enabled-modal',
					content: html
				})
			})
		}).on('click', '.product-competitor-price a', function(event) {
			$(this).closest('.product-competitor-price').toggleClass('show-popup');
		}).on('click','a[href="#"]',function(event){
			event.preventDefault();
		});
		
		$(".item", '#products, #recommended-products-container').off("touchend touchstart", '.item')
		.on('click', handleProductItemClick);

		if(front.getParam('autocomplete.enabled')===true) {
			autocomplete.init();
		}else if($('#search-box').length) {
			searchBox.initOff();
		}
		var lastSavedOrderLogData={};
		$('body').on('click','.js-link-to-www',function(){
			goToStandardSI();
			return false;
		}).on('click', '.js-native-app-back-button', function (event) {
			event.preventDefault();
			goBack.overlayBackOrClose();
		}).on('click', '[data-log-id]', function() {
			var $this=$(this);
			var data={
				id: $this.data('log-id'),
				f03: $this.data('user'),
				f04: '',
				f05: $this.data('order-number'),
				f06: $this.data('order-status'),
				f07: document.location.pathname,
				f08: '',
				f09: '',
				f10: $this.data('payment-type'),
				f11: $this.data('delivery-type')
			};
			lastSavedOrderLogData=$.extend({},data);
			log.event(data);
		}).on('click', '[data-save-log]', function() {
			var $this=$(this);
			var data=$.extend(true,lastSavedOrderLogData,{
				id: $this.data('save-id'),
				f07: document.location.pathname,
			});
			log.event(data);
		}).on('click','.js-add-to-cart',function(){
			// NA POTRZEBY TESTU AB - ZESTAWY DYNAMICZNE
			if ($(this).data('suite')) {
				const groupName = pageConfig.getData('productCard').groupName.split(" ").join("_");
				UA.interaction('KP_Zestawy', 'Dodanie_do_koszyka', `${groupName}_Domyslny`);
			}

			cartManager.addProduct({
				productId:$(this).data('product') || false,
				outletCategoryId: $(this).data('outlet-category') || false,
				outletProductId: $(this).data('outlet-product-id') || undefined,
				outletState: $(this).data('outlet-state') || false,
				relatedPromotionServiceId: $(this).data('related-promotion-service') || false,
				addedFrom:$(this).data('addedFrom') || false,
				warrantyAddedFrom:$(this).data('warranty-added-from') || false,
				delivery:$(this).data('delivery') || false,
				button: $(this).data('button') || false,
				productPLU: $(this).data('plu') || undefined,
				productPrice: $(this).data('product-price') || undefined
			});
		}).on('click', '.js-price-voucher-info',function(){
			modal.open('price-voucher-modal-'+$(this).data('product'));
		}).on('click', '.js-price-installment-voucher-info',function(){
			modal.open('price-installment-voucher-modal-'+$(this).data('product'));
		}).on('click', '.js-gnc-modal', function(e) {
			e.preventDefault();
			loading.start();
			message.get('modal-gnc-gwarancja-najnizszej-ceny').then(function(html){
				loading.stop();
				modal.generate({
					id:'gnc-modal',
					content: html
				})
			})
		}).on('click', '.js-price-installment-shop-info',function(){
			loading.start();
			message.get('instalments-with-advisor-only-modal').then(function(html){
				loading.stop();
				modal.generate({
					id: 'price-installment-shop-modal',
					content: html,
					modifier: 'remodal-full-width'
				});
			});
		}).on('click','.checkbox-css p.less a.show-more, .checkbox-css p.more a.show-less',function(){
			$(this).closest('.checkbox-css').toggleClass('checkbox-css-more');
		}).on('click','.js-hint-message',function(){
			$('#hint-message-'+$(this).data('id')).toggleClass('showed');
		}).on('click','.js-hint-close',function(){
			$(this).parent().removeClass('showed');
		}).on('click', '.js-toggle-footer-links', function() {
			const $button = $(this);
			$('#footer-links').toggleClass('open');
			const isExpanded = $('#footer-links').hasClass('open');
			$button.attr('aria-expanded', isExpanded ? 'true' : 'false');
			if (isExpanded) {
				// Autofocus na pierwszy dotychczas ukryty element listy w stopce
				$('#footer-links > ul > li:nth-child(6) > a').focus();
			}
		}).on('click', '.js-more-promotions', function () {
			let $product = $(this);
			productPromotionsListModal.show($product.data('product-id'), $(this).data('outlet-category-id'));
		}).on('paste keyup change', 'textarea[maxlength]', function(){
			$('.char-counter-current', $(this).parent()).text($(this).val().length);
		}).on('keyup', 'input[name*="companyName"]', function () {			// gdy pierwsze pole firma osiągnie swój limit zostaje przeniesione do drugiego pola
			var $this = $(this);
			if ($(this).val().length == $(this).attr('maxlength')) {
				let name = $this.attr('name');
				let newName = name.replace("Part1", "Part2");
				if (newName != name) {
					let $cont = $('input[name="' + newName + '"]');
					if ($cont.length) {
						console.log('osiągnięto limit w pierwszym polu firma, przeskok do pola: ' + newName);
						$cont.click().click().focus();
					}
				}
			}
			regulations.show();
		}).find('.js-add-to-compare').on('click', function (event) {
			const $this = $(this);
			comparisonButtonManager.toggleProduct({
				plu: $this.attr('data-plu'),
				category: $this.data('category'),
				thumbnail: $this.data('thumbnail'),
				name: $this.data('name')
			});
		});

		$('#footer-icon').on('click', 'a[href]:not(.link-mail)', function() {
			UA.interaction('Social', 'Footer', $(this).attr('title'));
		});
		$('.js-subscribe-newsletter').on('click', function(){
			// zapisanie do newslettera dla przycisku w komunikacie "stopka_bloczki"
			// główna metoda zapisująca do newslettera znajduje się w /cons/hotfix-edit.ucm?id=22789740553
			UA.interaction('Social', 'Footer', 'Mail - Zapis');
		  });

		if(cookie.get('atrUser')=='js'){
			html.add('atr-mode');
		}
		run();
	}

	function isAnchorOrButtonOrInput(element) {
		return ['INPUT', 'A', 'BUTTON'].includes(element.tagName) || $(element).closest('a, button, input').length;
	}

	function triggerClickOnProdcutName(item) {
		$(item)
			.find('.product-name a')
			.get(0)
			.click();
	}

	function handleProductItemClick(e) {
		const target = e.target;
		// zachowujemy domyślne działanie dla przycisków i linków
		if (isAnchorOrButtonOrInput(target)) {
			return;
		}
		const currentTarget = e.currentTarget;
		triggerClickOnProdcutName(currentTarget);
	}

	function goToStandardSI(){
		//TODO: wydzielić funkcję pozwalającą na przekierowanie do dużego SI zamiast cookie.setForceNormal
		var string=[];
		if ($('#page-not-available').length) {
			string.push('forceNormal=true');
		}else {
			cookie.setForceNormal();
		}
		/*
		if(this.logSearchValue && this.logSearchValue.keyword){
			string.push('keyword='+this.logSearchValue.keyword);
		}*/
		var url = front.getParam('hostname') + document.location.pathname + document.location.search;
		if(string.length){
			if(document.location.search.length) {
				url+="&"+string.join('&');
			} else {
				url+="?"+string.join('&');
			}
		}
		console.log('PRZEJŚCIE NA SI: '+url);
		loading.redirect(url);
	}

	function checkErrors() {
		var velocityError = [];
		var freemarkerError = [];
		$('.velocity-error').each(function () {
			velocityError.push($(this).text().trim());
		});
		$('meta[name=velocity-error]').each(function () {
			velocityError.push($(this).attr('content').trim());
		});
		$('.freemarker-error').each(function () {
			freemarkerError.push($(this).text().trim());
		});
		$('meta[name=freemarker-error]').each(function () {
			freemarkerError.push($(this).attr('content').trim());
		});

		velocityError.filter((x, i, a) => a.indexOf(x) == i).forEach(element => {
			UA.pageview('/blad-velocity-error' + document.location.pathname);
			log.event({
				id: 'blad-velocity-error',
				f03: document.location.pathname,
				f04: element
			});
		});

		freemarkerError.filter((x, i, a) => a.indexOf(x) == i).forEach(element => {
			UA.pageview('/blad-freemarker-error' + document.location.pathname);
			log.event({
				id: 'blad-freemarker-error',
				f03: document.location.pathname,
				f04: element
			});
		});
	}

	function getAdditionalPageContent() {
		$.ajax({
			url: '/additional-page-content.ltr',
			success: function(html) {
				$('head').append(html);
			}
		});
	}

	return {
		run:run,
		pageRun:pageRun
	};
});
